import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup} from "@angular/forms";
import {Lookups, RaceRegistration, StatementImportItem} from "@model";
import {required} from "@utility";

@Component({
  selector: 'registration-details-modal',
  templateUrl: './registration-details-modal.component.html',
  styleUrls: ['./registration-details-modal.component.scss']
})
export class RegistrationDetailsModalComponent {
  @Input() title: string | undefined;
  @Input() confirmButtonTitle: string | undefined;
  @Input() dismissButtonTitle: string | undefined;
  @Input() raceRegistration: RaceRegistration|undefined;
  @Input({required: true}) languages: Lookups[] = [];

  inputForm = new FormGroup({
    statementId: new FormControl(undefined, [
      required
    ]),
    statementDesc: new FormControl(undefined, [
      required
    ]),
  });

  constructor(public activeModal: NgbActiveModal) {
  }

  onConfirmClick(): void {
    let statementImportItem:StatementImportItem = new StatementImportItem();
    statementImportItem.id = this.inputForm.controls.statementId.value!;
    statementImportItem.note = this.inputForm.controls.statementDesc.value!;
    this.activeModal.close(statementImportItem);
  }

  onDismissClick(): void {
    /// https://github.com/ng-bootstrap/ng-bootstrap/issues/3721
    this.activeModal.dismiss();
  }
}

